import React, {Component} from "react";
import "./PisaasInstanceContainerInfoPopUp.css"
import Authentication from "../../authentication/Authentication";
import "./Whitelisting.css"

export default class Whitelisting extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentUrl: "",
            temporaryUrls: this.props.whitelistedUrls || [],
            showValidationMessage: false,
            showSchemaMessage: false
        };

        this.authentication = new Authentication();
    };

    handleReset = (originalUrls) => {
        this.setState({
            temporaryUrls: originalUrls,
            currentUrl: ""
        })
    }

    handleDelete = (currentList, urlToDelete) => {
        const newState = [...currentList]
        this.setState({
            temporaryUrls: newState.filter(url => {
                return url !== urlToDelete
            })
        })
    }

    handleAdd = (currentList, urlToAdd) => {
        if (this.isValid(urlToAdd)) {
            const newState = [...currentList]
            newState.push(urlToAdd)
            this.setState({
                temporaryUrls: newState,
                currentUrl: ""
            })
        }
    }

    isValid = (url) => {
        const urlSafeRegex = /^(http:\/\/|https:\/\/)(\*\.|[a-z0-9]+([-.]{1}[a-z0-9]+)*\.)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/

        return url.match(urlSafeRegex)
    }

    handleValueChange = (e) => {


        if (this.isValid(e.target.value)) {
            this.setState({
                showValidationMessage: false,
                currentUrl: e.target.value,
            })
        } else {
            this.setState({
                showValidationMessage: true,
                currentUrl: e.target.value,
            })
        }
    }

    render() {
        return (
            <>
                <div>
                    <h2 className={"config-header"} data-testid="config.header.whitelisting">Whitelisting</h2>
                    <ul data-testid="config.whitelisting.info">
                        <li>Click the edit button to add URL's to whitelist</li>
                        <li>Enter the URL and click the plus button to add a new URL</li>
                        <li>Make sure you save after editing</li>
                        <li>The dashboard will take around 5 minutes to update</li>
                    </ul>
                    <div className={"whitelist-header"}>
                        <p className={"field-name"} data-testid="config.whitelisting.URLs">Whitelisted URLs: </p>
                        <div className={"whitelist-buttons"} data-testid="config.whitelisting.buttons">
                            {this.props.showEditUrls ? <>
                                    <div data-testid="config.whitelisting.buttons.save" onClick={() => this.props.handleSubmit(this.state.temporaryUrls)}>
                                        <i className="fa fa-save whitelist-icon"/>
                                        <p>Save</p>
                                    </div>
                                    <div data-testid="config.whitelisting.buttons.reset" onClick={() => this.handleReset(this.props.whitelistedUrls)}>
                                        <i className="fa fa-undo whitelist-icon"/>
                                        <p>Reset</p>
                                    </div>
                                    <div data-testid="config.whitelisting.buttons.close" onClick={() => this.props.toggleEditUrls()}>
                                        <i className="fa fa-close whitelist-icon"/>
                                        <p>Close</p>
                                    </div>
                                </> :
                                <>
                                    <div>
                                        <i data-testid="config.whitelisting.buttons.refresh" onClick={() => this.props.whitelistedUrlsRefresh()} className="fa fa-refresh whitelist-icon"/>
                                        <p>Refresh</p>
                                    </div>
                                    <div data-testid="config.whitelisting.buttons.edit" onClick={() => this.props.toggleEditUrls()}>
                                        <i className="fa fa-edit whitelist-icon"/>
                                        <p>Edit</p>
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                    {this.props.requesting ?
                        <div className={"loading-container"} data-testid="config.whitelisting.loading.container">
                            Requesting...
                            <i className="fa fa-spinner fa-pulse fa-3x fa-fw edit-loading"/>
                        </div>
                        :
                        this.props.showEditUrls ?
                            <>
                                <div>
                                    <ul>
                                        {this.state.temporaryUrls.filter(url => url !== "self").map((url, index) => {
                                            return (
                                                <li value={url} className={"list-item"} key={index} data-testid="config.whitelisting.listItem.url">
                                                    {url}
                                                    <i data-testid="config.whitelisting.button.delete" onClick={() => this.handleDelete(this.state.temporaryUrls, url)} className="fa fa-trash add-delete-icon"/>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>
                                <input value={this.state.currentUrl} className={"whitelist-input"} data-testid="config.whitelisting.input.URL" type={"textarea"} onChange={(e) => this.handleValueChange(e)}/>
                                <i onClick={() => this.handleAdd(this.state.temporaryUrls, this.state.currentUrl)} className="fa fa-plus add-delete-icon" data-testid="config.whitelisting.button.add"/>
                                {this.state.showValidationMessage ? <p className={"warning-text"} data-testid="config.whitelisting.warning">Please enter a valid url</p> : <></>}
                                {this.state.showSchemaMessage ? <p className={"warning-text"} data-testid="config.whitelisting.warning">Please make sure your url begins with http or https</p> : <></>}

                            </> :
                            <div>
                                <ul>
                                    {this.props.whitelistedUrls.filter(url => url !== "self").map((url, index) => {
                                        return (
                                            <li className={"list-item"} key={index} data-testid="config.whitelisting.listItem.url">{url}</li>
                                        )
                                    })}
                                </ul>
                            </div>
                    }
                </div>
            </>
        )
    }
}



